module.exports = __webpack_public_path__ + "img/wps-thumbnail.6b37ff83.png";